import Vue from "vue";

export default {
  async createComment({ commit }, payload) {
    return Vue.axios.post(Vue.$url("comment/"), payload).then((rsp) => {
      Vue.$log.debug("comment created and saved under", rsp.data.id);
      commit("SET_NOOP", null, { root: true });
      // commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Comment', 1: payload.id }), { root: true });
      return rsp.data;
    });
  },

  async fetchComments({ commit }, dprId) {
    Vue.$log.debug("loading comments for dprId", dprId);

    return Vue.axios.get(Vue.$url("comment?dprId=" + dprId)).then((rsp) => {
      commit("SET_COMMENTS", rsp.data);
      return rsp.data || [];
    });
  },

  async updateComment({ commit }, payload) {
    return Vue.axios.put(Vue.$url("comment/" + payload.id), payload).then(() => commit("SET_NOOP", null, { root: true }));
    //commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Comment', 1: payload.id }), { root: true })
  },

  async updateFFComment({ commit }, payload) {
    return Vue.axios.put(Vue.$url("comment-wta/" + payload.id), payload).then(() => commit("SET_NOOP", null, { root: true }));
    //commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Comment', 1: payload.id }), { root: true })
  },

  async fetchSignatureComments({ commit }, dprFileId) {
    return Vue.axios.get(Vue.$url("dpr-signature-comments?dprFileId=" + (dprFileId || ""))).then((rsp) => {
      commit("SET_SIGNATURE_COMMENTS", rsp.data);
      return rsp.data || [];
    });
  },
};
